import { render, staticRenderFns } from "./MaintenanceRequest.vue?vue&type=template&id=778f1cd8&scoped=true&"
import script from "./MaintenanceRequest.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f1cd8",
  null
  
)

export default component.exports